import { JobFilters } from 'api/jobs';
import { hasAppliedJobFilters } from 'components/SearchFilters/appliedJobFilters';
import { JobStatus, JobType } from 'interfaces/job';
import { omit } from 'lodash';

const keysOwnedByTheSlideJobCondition = ['types', 'statuses', 'secondaryAnalysisFilter'];

export const withSlideJobCondition = (
  currentFilters: Partial<JobFilters> | null | undefined,
  next: { types?: string[]; statuses?: string[] }
): Partial<JobFilters> | null => {
  const preservedFilters = omit(currentFilters || {}, keysOwnedByTheSlideJobCondition);
  const types = next.types?.filter(Boolean) as JobType[] | undefined;
  const statuses = next.statuses?.filter(Boolean) as JobStatus[] | undefined;
  const nextFilters = {
    ...preservedFilters,
    ...(types?.length ? { types } : {}),
    ...(statuses?.length ? { statuses } : {}),
  };

  return hasAppliedJobFilters(nextFilters) ? nextFilters : null;
};
